/**
 * PDP2 (Redesign 2026-07) — Client-JS fuer die neue Fatboy-Produktseite.
 * Wird NUR von sections/main-product-pdp2.liquid geladen (templates/product.pdp2.json).
 *
 * Verantwortlich fuer:
 * 1. Info-Tabs: baut aus dem serverseitig gerenderten Accordion (snippets/pdp2-tabs.liquid)
 *    ab 990px zusaetzlich eine vertikale Tab-Leiste (kein Content-Duplikat, nur DOM-Umbau).
 * 2. Variantenwechsel: haengt sich an Dawns PUB_SUB_EVENTS.variantChange (aus
 *    <variant-selects>, assets/global.js) und aktualisiert Preis, Verfuegbarkeits-Modul,
 *    CTA-Text und Sticky-Bar direkt aus dem mitgelieferten variant-JSON — OHNE
 *    zusaetzlichen Netzwerk-Request, OHNE Abhaengigkeit von Dawns eigenem ID-basiertem
 *    HTML-Swap (der auf Dawns Original-Markup zielt, das wir hier nicht verwenden).
 *    Die Galerie selbst (Hauptbild-Wechsel) macht Dawn weiterhin automatisch
 *    (VariantSelects.updateMedia()), dafuer ist kein eigener Code noetig.
 * 3. Sticky-Add-to-Cart-Bar: Einblenden per IntersectionObserver, Klick-Proxy auf den
 *    echten Add-to-Cart-Button.
 * 4. SEO-Text (custom.seo_text): Clamp + "Mehr lesen"-Toggle, rein clientseitig, damit
 *    sections/richtext-one-field.liquid (geteilte Section, alle 48 Templates) unveraendert
 *    bleibt.
 *
 * Faellt dieses Script aus irgendeinem Grund aus (Fehler, JS deaktiviert): Tabs bleiben
 * ein funktionierendes natives Accordion, Preis/Verfuegbarkeit zeigen weiterhin den beim
 * Seitenaufruf serverseitig gerenderten Zustand (kein Layout-Bruch, nur kein Live-Update
 * ohne Reload).
 */
(function () {
  'use strict';

  /* ---------- Helpers ---------- */

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    return 'CHF ' + parts.join('.');
  }

  /* ---------- 1. Tabs ---------- */

  function initTabs() {
    var containers = document.querySelectorAll('[data-pdp2-tabs]');
    if (!containers.length) return;

    containers.forEach(function (container) {
      var acc = container.querySelector('.pdp2-acc');
      if (!acc) return;
      var items = Array.prototype.slice.call(acc.querySelectorAll('.pdp2-acc-item'));
      if (!items.length) return;

      // Sicherstellen, dass genau ein Tab initial offen ist.
      var hasOpen = items.some(function (item) {
        return item.hasAttribute('open');
      });
      if (!hasOpen) items[0].setAttribute('open', '');

      var tablist = document.createElement('div');
      tablist.className = 'pdp2-tablist';
      tablist.setAttribute('role', 'tablist');

      items.forEach(function (item, index) {
        var title = item.getAttribute('data-pdp2-tab-title') || '';
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'pdp2-tab';
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-selected', item.hasAttribute('open') ? 'true' : 'false');
        button.textContent = title;
        button.addEventListener('click', function () {
          items.forEach(function (otherItem, otherIndex) {
            var isActive = otherIndex === index;
            if (isActive) {
              otherItem.setAttribute('open', '');
            } else {
              otherItem.removeAttribute('open');
            }
          });
          Array.prototype.forEach.call(tablist.querySelectorAll('.pdp2-tab'), function (btn, btnIndex) {
            btn.setAttribute('aria-selected', btnIndex === index ? 'true' : 'false');
          });
        });
        tablist.appendChild(button);
      });

      container.insertBefore(tablist, acc);
    });

    document.documentElement.classList.add('pdp2-js');
  }

  /* ---------- 2. Variantenwechsel ---------- */

  function getLieferbarAbMap(sectionId) {
    var el = document.getElementById('Pdp2LieferbarAb-' + sectionId);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function updatePrice(sectionId, variant) {
    var wrap = document.getElementById('Pdp2Price-' + sectionId);
    if (!wrap) return;

    var price = variant.price;
    var compareAt = variant.compare_at_price;
    var showSale = typeof compareAt === 'number' && compareAt > price;

    var html = '<span class="pdp2-price tnum' + (showSale ? ' pdp2-price--sale' : '') + '">' +
      formatMoney(price) + '</span>';

    if (showSale) {
      html += '<span class="pdp2-was tnum">' + formatMoney(compareAt) + '</span>';
      html += '<span class="pdp2-save tnum">Du sparst ' + formatMoney(compareAt - price) + '</span>';
    }

    wrap.innerHTML = html;

    var badge = document.querySelector('#MainProduct-' + sectionId + ' .pdp2-badge-sale');
    if (badge) {
      if (showSale) {
        var badgePct = Math.round(((compareAt - price) / compareAt) * 100);
        badge.textContent = 'Sale ' + badgePct + '%';
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    }
  }

  function getI18n(sectionId) {
    var el = document.getElementById('Pdp2I18n-' + sectionId);
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function updateAvailabilityAndCta(sectionId, variant) {
    if (!variant.available) return;

    var t = getI18n(sectionId);
    var map = getLieferbarAbMap(sectionId);
    if (!map) return;

    var lieferbarAb = map[String(variant.id)] || '';
    var isLater = lieferbarAb !== '';

    var wrap = document.getElementById('Pdp2Availability-' + sectionId);
    if (wrap) {
      wrap.classList.toggle('pdp2-avail--later', isLater);
      wrap.classList.toggle('pdp2-avail--now', !isLater);
    }

    var title = document.getElementById('Pdp2AvailTitle-' + sectionId);
    var sub = document.getElementById('Pdp2AvailSub-' + sectionId);
    if (title) {
      title.textContent = isLater ? (t.availableFrom || 'Lieferbar ab') + ' ' + lieferbarAb : (t.availableNow || 'Sofort lieferbar');
    }
    if (sub) {
      var isAus = wrap && wrap.dataset && wrap.dataset.ausstellung === '1';
      sub.textContent = isLater
        ? (t.reservedNote || 'Wird für dich reserviert und zuerst geliefert.')
        : (isAus ? '' : (t.deliveryNote || 'Lieferung in 5 bis 9 Werktagen zu dir.'));
    }

    // CTA-Text ueberall gleich ("In den Warenkorb"), egal ob sofort oder Vorbestellung.
    var button = document.getElementById('ProductSubmitButton-' + sectionId);
    if (button && !button.hasAttribute('disabled')) {
      var span = button.querySelector('span');
      if (span) span.textContent = t.addToCart || 'In den Warenkorb';
    }

    // Lieferdatum-Property mit der gewaehlten Variante synchronisieren (frozen auf der Bestellung).
    if (button) {
      var lform = button.closest('form');
      var prop = lform && lform.querySelector('.pdp2-lieferbar-prop');
      if (prop) {
        prop.disabled = false;
        prop.value = isLater
          ? (t.availableFrom || 'Lieferbar ab') + ' ' + lieferbarAb
          : (t.availableNow || 'Sofort lieferbar');
      }
    }

    updateStickyCtaLabel(sectionId);
  }

  function updateStickyCtaLabel(sectionId) {
    var t = getI18n(sectionId);
    var cta = document.getElementById('Pdp2StickyCta-' + sectionId);
    if (cta) cta.textContent = t.addToCart || 'In den Warenkorb';
  }

  function updateStickyBar(sectionId, variant) {
    var thumbWrap = document.getElementById('Pdp2StickyThumb-' + sectionId);
    if (thumbWrap && variant.featured_image && variant.featured_image.src) {
      thumbWrap.src = variant.featured_image.src;
    }

    var price = document.getElementById('Pdp2StickyPrice-' + sectionId);
    if (price) price.textContent = formatMoney(variant.price);

    var meta = document.getElementById('Pdp2StickyMeta-' + sectionId);
    if (meta) {
      var t = getI18n(sectionId);
      var map = getLieferbarAbMap(sectionId);
      var lieferbarAb = map ? map[String(variant.id)] || '' : '';
      var fromLc = (t.availableFrom || 'lieferbar ab').toLowerCase();
      var nowLc = (t.availableNow || 'sofort lieferbar').toLowerCase();
      var statusText = lieferbarAb !== '' ? fromLc + ' ' + lieferbarAb : nowLc;
      var colorName = variant.option1 || variant.title || '';
      meta.textContent = colorName + ' · ' + statusText;
    }
  }

  function onVariantChange(event) {
    var data = event && event.data;
    if (!data || !data.variant) return;
    var sectionId = data.sectionId;

    updatePrice(sectionId, data.variant);
    updateAvailabilityAndCta(sectionId, data.variant);
    updateStickyBar(sectionId, data.variant);
    updateGalleryImage(sectionId, data.variant);
  }

  /* ---------- Galerie (eigene, schlanke Galerie) ---------- */
  function initGallery() {
    document.querySelectorAll('.pdp2-gallery').forEach(function (gal) {
      var sectionId = gal.dataset.section;
      var main = document.getElementById('Pdp2MainImg-' + sectionId);
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.pdp2-thumb'));
      function preload(url) { if (url) { var im = new Image(); im.decoding = 'async'; im.src = url; } }
      function activate(t) {
        if (main && t.dataset.full) {
          main.removeAttribute('srcset');
          main.src = t.dataset.full;
        }
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var ai = thumbs.indexOf(t);
        if (thumbs[ai + 1]) preload(thumbs[ai + 1].dataset.full);
        if (thumbs[ai - 1]) preload(thumbs[ai - 1].dataset.full);
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { activate(t); });
        t.addEventListener('mouseenter', function () { preload(t.dataset.full); });
      });
      // Nachbarbilder des Startbilds vorladen (schneller Pfeil-Wechsel)
      if (thumbs[0]) preload(thumbs[0].dataset.full);
      if (thumbs[1]) preload(thumbs[1].dataset.full);
      function idx() {
        var a = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
        return a < 0 ? 0 : a;
      }
      function go(i) {
        if (!thumbs.length) return;
        if (i < 0) i = thumbs.length - 1;
        if (i >= thumbs.length) i = 0;
        activate(thumbs[i]);
        thumbs[i].scrollIntoView({ inline: 'center', block: 'nearest' });
      }
      var prev = gal.querySelector('.pdp2-nav--prev');
      var next = gal.querySelector('.pdp2-nav--next');
      if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
      if (next) next.addEventListener('click', function () { go(idx() + 1); });

      /* ---- Thumbnail-Leiste per Pfeil scrollen ---- */
      var strip = document.getElementById('Pdp2Thumbs-' + sectionId);
      var tPrev = gal.querySelector('.pdp2-thumbs-nav--prev');
      var tNext = gal.querySelector('.pdp2-thumbs-nav--next');
      if (strip && (tPrev || tNext)) {
        function stripStep() {
          var first = strip.querySelector('.pdp2-thumb');
          var w = first ? first.getBoundingClientRect().width + 10 : 86;
          return Math.max(w, Math.floor(strip.clientWidth / w) * w - w);
        }
        function syncStripNav() {
          var max = strip.scrollWidth - strip.clientWidth - 1;
          if (tPrev) tPrev.disabled = strip.scrollLeft <= 0;
          if (tNext) tNext.disabled = strip.scrollLeft >= max;
        }
        if (tPrev) tPrev.addEventListener('click', function () { strip.scrollBy({ left: -stripStep(), behavior: 'smooth' }); });
        if (tNext) tNext.addEventListener('click', function () { strip.scrollBy({ left: stripStep(), behavior: 'smooth' }); });
        strip.addEventListener('scroll', syncStripNav, { passive: true });
        syncStripNav();
      }

      /* ---- Lightbox (Bild vergroessern + durchklicken) ---- */
      var lb = document.getElementById('Pdp2Lb-' + sectionId);
      if (lb) {
        // Aus dem sticky Gallery-Stacking-Context loesen, sonst liegt die Buy-Box drueber.
        document.body.appendChild(lb);
        var lbImg = document.getElementById('Pdp2LbImg-' + sectionId);
        var lbCount = document.getElementById('Pdp2LbCount-' + sectionId);
        var zoomList = thumbs.length
          ? thumbs.map(function (t) { return t.dataset.zoom || t.dataset.full; })
          : [(main && (main.dataset.zoom || main.src)) || ''];
        var lbIndex = 0;
        function lbShow(i) {
          if (!zoomList.length) return;
          if (i < 0) i = zoomList.length - 1;
          if (i >= zoomList.length) i = 0;
          lbIndex = i;
          if (lbImg) lbImg.src = zoomList[i];
          if (lbCount) lbCount.textContent = (i + 1) + ' / ' + zoomList.length;
          preload(zoomList[(i + 1) % zoomList.length]);
          preload(zoomList[(i - 1 + zoomList.length) % zoomList.length]);
          if (thumbs[i]) activate(thumbs[i]); // Hauptgalerie mitziehen
        }
        function lbOpen() {
          lbShow(thumbs.length ? idx() : 0);
          lb.hidden = false;
          document.documentElement.classList.add('pdp2-lb-open');
        }
        function lbClose() {
          lb.hidden = true;
          document.documentElement.classList.remove('pdp2-lb-open');
        }
        if (main) {
          // Auf Touch nur zoomen bei echtem Tap (kein Wisch) — sonst blockiert der
          // Bild-Klick das vertikale Scrollen, weil das Bild fast den Viewport fuellt.
          var tsx = 0, tsy = 0, tMoved = false;
          main.addEventListener('touchstart', function (e) {
            var t = e.touches[0]; tsx = t.clientX; tsy = t.clientY; tMoved = false;
          }, { passive: true });
          main.addEventListener('touchmove', function (e) {
            var t = e.touches[0];
            if (Math.abs(t.clientX - tsx) > 10 || Math.abs(t.clientY - tsy) > 10) tMoved = true;
          }, { passive: true });
          main.addEventListener('click', function () { if (!tMoved) lbOpen(); });
        }
        var zh = gal.querySelector('.pdp2-zoom-hint');
        if (zh) zh.addEventListener('click', function (e) { e.stopPropagation(); lbOpen(); });
        var lbCloseBtn = lb.querySelector('.pdp2-lb__close');
        if (lbCloseBtn) lbCloseBtn.addEventListener('click', lbClose);
        var lbPrev = lb.querySelector('.pdp2-lb__nav--prev');
        var lbNext = lb.querySelector('.pdp2-lb__nav--next');
        if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbIndex - 1); });
        if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbIndex + 1); });
        lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
        document.addEventListener('keydown', function (e) {
          if (lb.hidden) return;
          if (e.key === 'Escape') lbClose();
          else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
          else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
        });
      }
    });
  }

  function updateGalleryImage(sectionId, variant) {
    var main = document.getElementById('Pdp2MainImg-' + sectionId);
    if (main && variant.featured_image && variant.featured_image.src) {
      main.removeAttribute('srcset');
      main.src = variant.featured_image.src;
    }
    var mid = (variant.featured_media && variant.featured_media.id) ||
              (variant.featured_image && variant.featured_image.id);
    if (mid) {
      document.querySelectorAll('#Pdp2Thumbs-' + sectionId + ' .pdp2-thumb').forEach(function (t) {
        t.classList.toggle('is-active', String(t.dataset.mediaId) === String(mid));
      });
    }
  }

  function initVariantChangeListener() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
  }

  /* ---------- 3. Sticky-Bar Sichtbarkeit + Klick-Proxy ---------- */

  function initStickyBar() {
    var bars = document.querySelectorAll('.pdp2-stickybar');
    if (!bars.length || typeof IntersectionObserver === 'undefined') return;

    bars.forEach(function (bar) {
      var sectionId = bar.dataset.section;
      var ctaWrap = document.querySelector('#MainProduct-' + sectionId + ' .pdp2-ctawrap');
      if (!ctaWrap) return;

      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('pdp2-show', scrolledPast);
          // Chat-Bubble anheben, solange die Kaufleiste sichtbar ist (sonst deckt sie den Button ab)
          document.documentElement.classList.toggle('pdp2-bar-visible', scrolledPast);
        },
        { threshold: 0 }
      );
      observer.observe(ctaWrap);

      var cta = document.getElementById('Pdp2StickyCta-' + sectionId);
      if (cta) {
        cta.addEventListener('click', function () {
          var targetId = cta.dataset.targetSubmit;
          var targetButton = document.getElementById(targetId);
          if (targetButton && !targetButton.hasAttribute('disabled')) {
            targetButton.click();
          }
        });
      }
    });
  }

  /* ---------- 4. SEO-Text Clamp ---------- */

  function initSeoClamp() {
    var field = document.querySelector('[id*="seo-text"] .richtext-single-field');
    if (!field) return;

    var section = document.querySelector('[id*="seo-text"]');

    var wrap = document.createElement('div');
    wrap.className = 'pdp2-seowrap';

    var content = document.createElement('div');
    content.className = 'pdp2-seo-content';
    while (field.firstChild) {
      content.appendChild(field.firstChild);
    }

    var fade = document.createElement('div');
    fade.className = 'pdp2-seo-fade';
    fade.setAttribute('aria-hidden', 'true');

    wrap.appendChild(content);
    wrap.appendChild(fade);
    field.appendChild(wrap);

    var moreButton = document.createElement('button');
    moreButton.type = 'button';
    moreButton.className = 'pdp2-seo-more';
    moreButton.textContent = 'Mehr lesen';
    moreButton.hidden = true;
    field.appendChild(moreButton);

    requestAnimationFrame(function () {
      if (content.scrollHeight <= 320) return;

      content.classList.add('pdp2-clamped');
      fade.classList.add('pdp2-seo-fade--visible');
      moreButton.hidden = false;

      moreButton.addEventListener('click', function () {
        // classList.toggle returns true if the class is present after toggling.
        var stillClamped = content.classList.toggle('pdp2-clamped');
        fade.classList.toggle('pdp2-seo-fade--visible', stillClamped);
        moreButton.textContent = stillClamped ? 'Mehr lesen' : 'Weniger anzeigen';
      });
    });
  }

  /* ---------- Init ---------- */

  /* ---------- Verfuegbarkeits-Punkte an den Farb-Swatches ---------- */
  function initSwatchDots() {
    document.querySelectorAll('[id^="Pdp2SwatchAvail-"]').forEach(function (el) {
      var sectionId = el.id.replace('Pdp2SwatchAvail-', '');
      var map;
      try { map = JSON.parse(el.textContent); } catch (e) { return; }
      var scope = document.getElementById('MainProduct-' + sectionId) || document;
      scope.querySelectorAll('.product-form__input--pill input').forEach(function (inp) {
        var label = document.querySelector('label[for="' + inp.id + '"]') || inp.nextElementSibling;
        if (!label) return;
        var date = map[inp.value];
        label.classList.remove('pdp2-swatch--now', 'pdp2-swatch--later');
        label.classList.add(date && String(date).length ? 'pdp2-swatch--later' : 'pdp2-swatch--now');
      });
    });
  }

  /* ---------- Klick auf Sterne/„X Bewertungen" scrollt zu den Reviews ---------- */
  function initRatingScroll() {
    var rating = document.querySelector('.pdp2-rating');
    if (!rating) return;
    var target = document.querySelector('[id*="reviews-app"]');
    if (!target) return;
    rating.style.cursor = 'pointer';
    rating.addEventListener('click', function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function initInitialState() {
    document.querySelectorAll('[id^="Pdp2Availability-"]').forEach(function (el) {
      var sectionId = el.id.replace('Pdp2Availability-', '');
      var scope = document.getElementById('MainProduct-' + sectionId) || document;
      var idInput = scope.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;
      updateAvailabilityAndCta(sectionId, { id: idInput.value, available: true });
    });
  }

  function init() {
    initTabs();
    initGallery();
    initVariantChangeListener();
    initStickyBar();
    initSeoClamp();
    initSwatchDots();
    initRatingScroll();
    initInitialState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
